import Button from "../components/Button";
import PageTitle from "../components/PageTitle";
import ShopexOffer from "../components/home/ShopexOffer";

export default function About() {
  return (
    <>
      <PageTitle title={"Blog Page"} path={["Pages", "Blog Page"]} />
      <div className=" max-w-5xl mx-auto flex mt-12 mb-32">
        {/* image */}
        <div className="w-full p-4">
          {/* image container */}
          <div className=" w-full bg-red-200 h-80 rounded-md overflow-hidden shadow-about_section">
            <img
              alt=""
              className="w-full h-full object-cover"
              src={require("../assets/about/img01.png")}
            />
          </div>
        </div>
        {/* text */}
        <div className="w-full flex flex-col items-start justify-center">
          <h1 className=" font-fontOne font-bold text-2xl">
            Know About Our Ecommerce Business, History
          </h1>
          <p className=" text-sub_text_color mb-8">
            Eu incididunt aliqua culpa deserunt fugiat eiusmod culpa eu eiusmod
            dolor dolore eu. Occaecat sunt amet excepteur in velit veniam do ut
            incididunt culpa qui id do. Consequat id deserunt pariatur
            consectetur id adipisicing ea irure id officia sit ipsum. Labore id
            irure deserunt sunt mollit proident aute dolore. Esse labore amet eu
            irure excepteur exercitation anim eiusmod exercitation culpa elit
            esse enim.
          </p>
          <Button color={"pink"}>Contact Us</Button>
        </div>
      </div>
      <ShopexOffer />
      <div className=" bg-[#FBFBFF] w-full">
        <div className=" max-w-5xl mx-auto flex flex-col items-center py-12">
          <h2 className=" text-3xl font-bold font-fontOne">Our Clients Say!</h2>
          <div className="flex mt-8">
            {/* image container */}
            <div className=" w-16 bg-blue-500 h-16 mt-3 rounded-sm overflow-hidden">
              <img
                alt=""
                className="w-full h-full object-cover"
                src={require("../assets/about/img02.png")}
              />
            </div>
            <div className=" w-16 bg-blue-500 h-16 mx-3 rounded-sm overflow-hidden">
              <img
                alt=""
                className="w-full h-full object-cover"
                src={require("../assets/about/img03.png")}
              />
            </div>
            <div className=" w-16 bg-blue-500 h-16 mt-3 rounded-sm overflow-hidden">
              <img
                alt=""
                className="w-full h-full object-cover"
                src={require("../assets/about/img04.png")}
              />
            </div>
          </div>
          <h3 className="text-xl font-bold font-fontOne mt-5">Steve Musk</h3>
          <p className=" text-sub_text_color text-xs">dskfjoi we asdfn</p>
          <p className=" text-sub_text_color text-center text-sm max-w-3xl mt-3">
            Voluptate culpa consectetur consequat eu voluptate ullamco officia
            minim fugiat. Voluptate adipisicing id sunt non cupidatat excepteur
            ipsum tempor ea culpa pariatur nisi aliqua. Exercitation sint elit
            ea ad.
          </p>
        </div>
      </div>
    </>
  );
}
